(function () {
    'use strict';

    angular
        .module('harriApp')
        .service('barriAnalyticsService', BarriAnalyticsService);

    function BarriAnalyticsService() {
        let self = this;
        const _allowedBarriRoutes = {};
        const _userBarriPrivileges = {};

        self.getUserBarriAllowedRoutes = async function (brandId, userId) {
            try {
                let allowedBarriRoutes = _allowedBarriRoutes[brandId];

                if (allowedBarriRoutes) {
                    return allowedBarriRoutes;
                }

                allowedBarriRoutes = [];
                const privileges = await self.getUserBarriPrivileges(brandId, userId);

                privileges.forEach(privilege => {
                    switch (privilege) {
                        case 'PR_VIEWER':
                            allowedBarriRoutes.push('liveboards', 'home');
                            break;
                        case 'PR_DESIGNER':
                            allowedBarriRoutes.push('liveboards', 'home', 'search');
                            break;
                        case 'PR_SPOT_IQ':
                            allowedBarriRoutes.push('liveboards', 'home', 'spot-iq', 'search');
                            break;
                    }
                });

                _allowedBarriRoutes[brandId] = allowedBarriRoutes;
                return allowedBarriRoutes;
            } catch (error) {
                throw error;
            }
        };

        self.getUserBarriPrivileges = async function (brandId, userId) {
            try {
                if (_userBarriPrivileges[brandId]) {
                    return _userBarriPrivileges[brandId];
                }

                const privileges = await ThoughtSpotAnalyticsAPI.getUserPrivileges(brandId, userId);
                const userPrivileges = privileges.map(prv => prv.acl_group_name_code);
                _userBarriPrivileges[brandId] = userPrivileges;
                return userPrivileges;
            } catch (error) {
                throw error;
            }
        };

    }

    BarriAnalyticsService.$inject = [];

})();
